module.exports = __webpack_public_path__ + "img/shareFixedImg.76ec6d57.png";